import { createFileRoute } from '@tanstack/react-router';
import { createRouteConfig } from '../utils/routeGuard';
import { Header } from '@/components/public/Header';
import { BackLink } from '@/components/public/BackLink';
import { Hero } from '@/components/public/mobile/Hero';
import { Screens } from '@/components/public/mobile/Screens';
import { FeatureGrid } from '@/components/public/mobile/FeatureGrid';
import { HowItWorks } from '@/components/public/mobile/HowItWorks';
import { Footer } from '@/components/Footer';
import { CTA } from '@/components/public/mobile/CTA';

export const Route = createFileRoute('/mobile')({
  component: Mobile,
  ...createRouteConfig({
    isPublic: true,
  }),
});

function Mobile() {
  return (
    <div className='min-h-screen bg-white text-slate-900'>
      <Header />
      <BackLink />
      <Hero />
      <Screens />
      <FeatureGrid />
      <HowItWorks />
      <CTA />
      <Footer />
    </div>
  );
}
